import React, { useContext } from 'react';
import pluralize from 'pluralize';

import { media } from 'context';
import { Button, Layout, Modal, ProductImg, Text } from 'ds';
import { ConsumablesProduct } from 'shared';
import PriceTag from 'ux/Tenant/PriceTag';

import ConsumablesProductAddQuantity from '../ConsumablesProductAddQuantity';
import ReadMoreText from '../ReadMoreText';

interface ConsumablesOnboardingProductModalProps {
  isProductModalVisible: boolean;
  selectedProduct: ConsumablesProduct | null;
  onClose: () => void;
  handleAddProduct: () => void;
  selectedProductQuantity: number;
  setSelectedProductQuantity: (quantity: number) => void;
}

const ConsumablesOnboardingProductModal: React.FC<ConsumablesOnboardingProductModalProps> = ({
  isProductModalVisible,
  onClose,
  selectedProduct,
  handleAddProduct,
  selectedProductQuantity,
  setSelectedProductQuantity
}) => {
  const { isMobile } = useContext(media);

  return (
    <Modal
      showSideDrawerScrim={true}
      topLeft
      width={422}
      paddingX={24}
      footer={<Button fullWidth text={'Add'} size="md" type="primary" onClick={handleAddProduct} />}
      isSideDrawer={true}
      isVisible={isProductModalVisible}
      onClose={onClose}
      bottomSheetIsRounded
      hasBottomSheetPaddingX
      overflow="visible"
    >
      <Layout flex direction="column">
        <Layout flex justify="center" align="center" {...(isMobile ? { paddingY: 24 } : {})}>
          {selectedProduct && (
            <ProductImg
              srcKey={selectedProduct.image_key}
              size="lg"
              alt={selectedProduct.detail}
              style={{ width: 224, height: 224 }}
            />
          )}
        </Layout>
        <Layout
          flex
          direction="column"
          gap={12}
          {...(isMobile ? { paddingTop: 16, paddingBottom: 32 } : { paddingY: 24 })}
        >
          <Text size="body-lg">
            {selectedProduct?.brand} {selectedProduct?.detail} {pluralize(selectedProduct?.unit_type ?? '', 2)} (
            {selectedProduct?.units_per_package}/{selectedProduct?.package_type})
          </Text>
          <ReadMoreText text={selectedProduct?.detail as string} maxLines={2} />
          <PriceTag amountCents={selectedProduct?.amount_cents ?? 0} unitLabel={isMobile ? 'ea.' : undefined} />
        </Layout>
        <Layout minHeight={8} color="gray-25" position="relative" left={-24} width="calc(100% + 48px)" />
        <ConsumablesProductAddQuantity
          title={'Add quantity:'}
          selectedProductQuantity={selectedProductQuantity}
          setSelectedProductQuantity={setSelectedProductQuantity}
          selectedProduct={selectedProduct}
        />
      </Layout>
    </Modal>
  );
};

export default ConsumablesOnboardingProductModal;
